export default __webpack_public_path__ + "static/media/eu-flag.6a6e0761.png";